import { showErrorNotification, showSuccessNotification } from './notifications';
import { rejectBfcException, updateRejectionReason } from '../compliance/sox';
import dynamicKendoGrid from '../reporting/dynamicKendoGrid';
import _bundle from '../../core/core--bundles';
import textareaAutoHeight from '../../modules/modue--textareaAutoHeight';
import { removeDefaultDates } from '../project-review/mprExecutiveSummary';
import getBodySettings from './page-settings';
import { attachCommentSave } from '../dashboards/accrual/corporate-questions';
import {
    approveButtonEvent,
    approveGridInit,
    commentButtonEvent,
    commentHistoryEvent,
} from '../operations/pcoDetailModals';
import { invoiceGridInit } from '../cash/cash-collections-modal';

const { nameArea, nameController, nameAction, namePage } = getBodySettings('page');

export let WindowEvents = {
    onOpenEvents: {},
    onCloseEvents: {},
    onRefreshEvents: {},
};

export default function() {
    _bundle.add({
        name: 'Kendo Windows: Check page for kendo windows and attach events',
        event: ['on:BundleReady', 'on:PageUpdate'],
        fn() {
            if ($('[data-kendoWindow]').length || $('[data-role="window"]').length) {
                windowTriggers();
                openCloseWindow();
            }
        },
    });
}

export const windowTriggers = function() {
    const $windows = $('.k-window-content');
    if ($windows.length) {
        const onOpen = function() {
            const $ele = this.element;
            const id = $ele.attr('id');
            if (id !== 'pcoWindow') {
                // Prevent background scrolling
                $('html, body').css('overflow', 'hidden');
                if (id === 'PmOmChecklistModal') {
                    $ele.parent().addClass('--tall');
                }

                $ele.parent().css('top', '').css('left', '').addClass('centerWindow');

                if ($ele.attr('id') === 'calculationWindow') {
                    $ele.parent().addClass('calculationWindow');
                }
            }
        };
        const onClose = function() {
            // restore default scrolling
            $('html, body').css('overflow', '');
        };
        const tempCloseEvents = {
            aiCreationPopup() {
            },
            approvalRemovalPopup() {
            },
            RejectionReasonWindow() {
                const $ele = this.element;
                const k_window = $ele.data('kendoWindow');
                if (k_window) {
                    const $rejectReason = $ele.find('#rejectReason');
                    if ($rejectReason.length) {
                        $rejectReason.val('');
                    }
                }
            },
            lookupGrid_Window() {
                const $grid = $('#lookupGrid');
                if ($grid.length) $grid.html('');
            },
            bfcReport() {
                const $reportGrid = $('#bfcReportGrid');
                if ($reportGrid.length) $reportGrid.html('');
            },
            cashForecast() {
                resetSpinner(this.element, 'Fetching Invoices...');
            },
            cashCollectionReceived() {
                // Nothing to do, leaving function as placeholder
            },
            invoiceComments() {
                resetSpinner(this.element, 'Fetching Comments...');
            },
            AdditionalInformationWindow() {
                this.element.find('#loading.spinner').show();
                $('.js-previous-comments').html('');
                $('.js-send-back').hide();
                $('.js-send-reply').hide();
            },
            ChangeOrderWindow() {
                /* Nothing to do */
            },
            ViewpointAttachments() {
                resetSpinner(this.element, 'Fetching Attachments...');
            },
            PriorQuarterInvoices: function() {

            },
            ManualInvoiceWindow() {
                const $ele = $(this.element);
                const data = $ele.find('form').serialize();

                $.post('/Finance/CancelManualEntry', data, function() {
                    resetSpinner($ele, 'Loading Form...');
                });
            },
            SgaExplanationWindow() {
                // resetSpinner(this.element, "Loading Explanation...");
            },
            SgaAttachmentWindow() {
                resetSpinner(this.element, 'Loading Attachments...');
            },
            PmOmChecklistModal() {
                resetSpinner(this.element, 'Loading Checklist...');
            },
            PcoApprovalModal() {
                resetSpinner(this.element, 'Loading Form...');
            },
            PcoCommentModal() {
                resetSpinner(this.element, 'Loading Form...');
            },
            PcoCommentHistoryModal() {
                resetSpinner(this.element, 'Loading Comments...');
            },
            AddProjectionItemModal() {
                const $self = $(this.element);
                const $description = $self.find('[name=Description]');
                const $comments = $self.find('[name=Comments]');
                $description.val('');
                $description.keyup();
                $self.find('[name=ExpectedRecoveryAmount]').data('kendoNumericTextBox').value('');
                $comments.val('');
                $comments.keyup();
            },
            NewMaintenancePlanModal() {

            },
            CommissionsReject() {

            },
        };
        const onCloseEvents = Object.assign(WindowEvents.onCloseEvents, tempCloseEvents);
        const tempOpenEvents = {
            pcoWindow() {
                placeWindow();
            },
            reportWindow() {
                const $ele = this.element;
                const k_window = $ele.data('kendoWindow');
                if (k_window) {
                    const $attachIcon = k_window.wrapper.find('.k-i-attachment-45');
                    if ($attachIcon.length) {
                        $attachIcon.click(function() {
                            const url = k_window.wrapper.find('#ssrsReportViewer').attr('src');
                            const queryString = url.split('?')[1];

                            const data = {
                                pid: parseInt($('#Project_Pid').val()),
                                mid: $('#Id').val() || -1,
                                section: $('#sectionName').val(),
                                export: 'EXCEL',
                            };

                            $('#attachmentContainer').load(`/Reporting/Ssrs/SaveAttachment?${queryString}`, data, function(data, status) {
                                if (status === 'success') {
                                    showSuccessNotification('File Attached');
                                } else {
                                    showErrorNotification('Failed to Attach File!');
                                }
                            });
                        });
                    }
                }
            },
            RejectionReasonWindow() {
                const $ele = this.element;
                const k_window = $ele.data('kendoWindow');
                if (k_window) {
                    const $soxId = $('#currentSoxId');

                    if ($soxId.length) {
                        const soxId = $soxId.val();
                        const $textarea = $ele.find('textarea');
                        const $rejectException = $('#rejectException');
                        if ($textarea.length) {
                            $textarea.keyup(function() {
                                updateRejectionReason(soxId, this.value);
                            });
                        }

                        if ($rejectException.length) {
                            $rejectException.unbind('click');
                            $rejectException.click(function() {
                                event.preventDefault();
                                rejectBfcException(soxId);
                            });
                        }
                    }
                }
            },
            bfcReport() {
                const $reportGrid = $('#bfcReportGrid');
                $('#loading.spinner').show();
                if ($reportGrid.length) {
                    let runMonth = $('#SoxMonth').val();
                    if (runMonth) {
                        runMonth = runMonth.replace('/', '/1/');
                    }
                    dynamicKendoGrid($reportGrid, 'complianceSox_GetBfc03ExceptionsLiveData', `Company:${$reportGrid.data('company')},Mth:${runMonth}`, 'none', 'BFC03')
                        .finally(() => {
                            $('#loading.spinner').hide();
                        });
                }
            },
            cashForecast() {
                const $ele = this.element;
                const k_window = $ele.data('kendoWindow');
                const data = {
                    company: $('[data-company]').data('company'),
                    contract: $ele.data('project-id'),
                    week: $ele.data('week-id').toLowerCase(),
                    isArAging: Boolean($ele.data('is-ar-aging')),
                    custId: $ele.data('cust-id'),
                    custName: $ele.data('cust-name'),
                    type: $ele.data('project-type'),
                };
                const isProject = data.type.toLowerCase() === 'project';
                if (!isProject) {
                    data.contract += '-s';
                }
                if (k_window) {
                    if (data.isArAging) {
                        let column = '';
                        switch (data.week) {
                            case 'arage0_30' : {
                                column = 'Current AR (0-30 days)';
                                break;
                            }
                            case 'arage31_60' : {
                                column = 'AR 31-60';
                                break;
                            }
                            case 'arage61_90' : {
                                column = 'AR 61-90';
                                break;
                            }
                            case 'arageOver_90' : {
                                column = 'AR Over 90';
                                break;
                            }
                        }
                        if (isProject) setTitle(k_window, `${data.contract} - ${column}`);
                        else setTitle(k_window, `${data.custId} - ${data.custName}`);
                    } else {
                        if (isProject) setTitle(k_window, `${data.contract} - Week Ending ${$ele.data('week-id')}`);
                        else setTitle(k_window, `${data.custId} - ${data.custName} - Week Ending ${$ele.data('week-id')}`);
                    }

                }

                // Correct Week data
                if (data.week !== 'future' && !data.isArAging) {
                    let tempWeek = `${data.week}/${new Date().getFullYear()}`;

                    if ((new Date(tempWeek) - new Date()) / (6 * 24 * 60 * 60 * 1000) < -1) {
                        // Date rolled over to next year
                        tempWeek = `${data.week}/${new Date().getFullYear() + 1}`;
                    }

                    if ((new Date(tempWeek) - new Date()) / (6 * 24 * 60 * 60 * 1000) < 1) {
                        // Using 6 since it uses the start of the day
                        // Date is within a week so it is the current week
                        tempWeek = 'current';
                    }

                    data.week = tempWeek;
                }

                // Load Invoice Modal
                $ele.load('/Account/Finance/CashInvoiceModal', data, function() {
                    //Set Data for form
                    if (data.type !== 'project') {
                        $ele.find('[name="Contract"]').val(`${data.custId}`);
                    } else {
                        $ele.find('[name="Contract"]').val(data.contract);
                    }
                    $ele.find('[name="Week"]').val(data.week);
                    $ele.find('[name="IsArAging"]').val(data.isArAging);
                    $ele.find('[name="CustId"').val(data.custId);
                    invoiceGridInit($('.cash-edit-grid'));

                    removeDefaultDates();

                    // Force Date
                    const $form = $('form#InvoiceAssignmentForm');
                    const $assignmentDate = $form.find('#AssignmentDate');

                    $assignmentDate.on('blur', function() {
                        if ($assignmentDate.length) {
                            const k_assignmentDate = $assignmentDate.data('kendoDatePicker');

                            if (k_assignmentDate.value() == null) {
                                // Date Changed Manually
                                const value = new Date($assignmentDate.val());
                                const daysToAdd = 6 - (value.getDay() + 1) % 7;

                                k_assignmentDate.value(value.addDay(daysToAdd));
                            }

                        }
                    });

                    setUpTextArea();
                });
            },
            cashCollectionReceived() {
                // Nothing to do, leaving function as placeholder
            },
            invoiceComment() {
                const $ele = this.element;
                const k_window = $ele.data('kendoWindow');

                const invoiceId = $ele.data('invoice-number');
                const gridId = $ele.data('parent-grid-id');
                const g = $(`#${gridId}`).data('kendoGrid');
                const gds = g.dataSource;
                const dataItem = gds.get(invoiceId);

                const data = {
                    qid: $ele.data('qid'),
                    userName: dataItem.Comment?.Commenter?.FullName,
                    commentDate: kendo.parseDate(dataItem.Comment?.Date),
                    comment: dataItem.Comment?.CommentText,
                    tpId: $ele.data('third-party-id'),
                    invoiceId,
                };
                const firstComment = (data.comment === 'undefined' || data.comment === undefined);


                $ele.empty();
                $ele.addClass('js-invoice-comments');
                $ele.data('flex', 'columns: 24, gap-row: true, align: middle');

                if (k_window) {
                    setTitle(k_window, `Comment on Invoice Number ${data.invoiceId}`);
                }

                const addDiv = $('<div class="invoice-change" style="padding-top: 1ch;"></div>');
                addDiv.data('flex-item', 'width: 24');
                let addBtnText = 'Update Comment';
                if (firstComment) addBtnText = 'Add Comment';
                const addBtn = $(`<button class="k-primary">${addBtnText}</button>`);
                addBtn.kendoButton({
                    click(e) {
                        const that = e.sender.element;
                        const commentDisplay = that.parent().siblings('.invoice-comment');
                        const commentChange = that.parent();
                        const commentUpdate = that.parent().siblings('.invoice-update');
                        commentChange.toggle();
                        commentDisplay.toggle();
                        commentUpdate.toggle();
                        $('#newInvoiceComment').focus();
                    },
                });
                addDiv.append(addBtn);

                const updateDiv = $('<div class="invoice-update" style="padding-top: 1ch;"></div>');
                updateDiv.data('flex-item', 'width: 24');
                const updateBtn = $('<button id="invoiceCommentUpdate" class="k-primary">Update Comment</button>');
                updateBtn.kendoButton({
                    click(e) {
                        const b = nameAction.toLowerCase().includes('subcontract');
                        const a = b ? 'SubContractInvoiceComment' : 'MaterialInvoiceComment';
                        const ep = `/Account/Accruals/${a}`;
                        const postData = {
                            qid: data.qid,
                            comment: $('#newInvoiceComment').val(),
                            invoiceId: data.invoiceId,
                        };
                        if (b) postData.contractorId = data.tpId;
                        else postData.vendorId = data.tpId;
                        $.post({
                            url: ep,
                            data: postData,
                            success(r, s, x) {
                                g.dataSource.read();
                                k_window.close();
                                showSuccessNotification(`Comment on invoice ${data.invoiceId} saved.`);
                            },
                        });
                    },
                });
                const cancelBtn = $('<button id="invoiceCommentCancel">  Cancel</button>');
                cancelBtn.kendoButton({
                    click(e) {
                        const that = e.sender.element;
                        const commentDisplay = that.parent().siblings('.invoice-comment');
                        const commentChange = that.parent().siblings('.invoice-change');
                        const commentUpdate = that.parent().parent().children('.invoice-update');
                        commentDisplay.toggle();
                        commentChange.toggle();
                        commentUpdate.toggle();
                    },
                });
                updateDiv.append(updateBtn);
                updateDiv.append(cancelBtn);
                updateDiv.toggle();

                const commentDiv = document.createElement('div');
                commentDiv.setAttribute('class', 'invoice-comment');

                const commentText = document.createElement('p');
                commentText.setAttribute('style', 'padding-left: 5px');
                commentDiv.setAttribute('data-flex-item', 'width: 24');

                if (firstComment) commentText.append('No comment');
                else commentText.append(data.comment);
                commentDiv.append(commentText);

                if (!firstComment) {
                    const createdBy = document.createElement('p');
                    createdBy.setAttribute('class', 't-italic t-muted');
                    createdBy.setAttribute('data-flex-item', 'width:24');
                    const createdByText = `Comment updated by ${data.userName} on ${kendo.toString(data.commentDate, 'd')}`;
                    createdBy.append(createdByText);
                    commentDiv.append(createdBy);
                }

                const commentAdd = document.createElement('div');
                commentAdd.setAttribute('class', 'invoice-update form-item');
                commentAdd.setAttribute('data-flex-item', 'width: 24');

                const commentInput = document.createElement('textarea');
                commentInput.setAttribute('id', 'newInvoiceComment');
                commentInput.setAttribute('class', 'form-item__autoheight k-textbox');
                commentInput.setAttribute('style', 'width: 100%; overflow: hidden; position: absolute; top: 0px; left: 0px; height: 100%; resize: none;');
                commentInput.setAttribute('value', data.comment ?? '');
                commentInput.value = data.comment ?? '';
                commentAdd.append(commentInput);
                $(commentAdd).toggle();

                $ele.append(commentDiv);
                $ele.append(commentAdd);
                $ele.append(addDiv);
                $ele.append(updateDiv);

                setUpTextArea();
            },
            invoiceComments() {
                const $ele = this.element;
                const k_window = $ele.data('kendoWindow');
                const data = {
                    contract: $ele.data('project-id'),
                    week: $ele.data('week-id').toLowerCase(),
                    readOnly: $ele.data('read-only'),
                };

                if (k_window) {
                    setTitle(k_window, `${data.contract} - Week Ending ${$ele.data('week-id')}`);
                }

                // Correct Week data
                if (data.week !== 'future') {
                    let tempWeek = `${data.week}/${new Date().getFullYear()}`;

                    if ((new Date(tempWeek) - new Date()) / (6 * 24 * 60 * 60 * 1000) < -1) {
                        // check that its older than a week ago
                        // Date rolled over to next year
                        tempWeek = `${data.week}/${new Date().getFullYear() + 1}`;
                    }

                    if ((new Date(tempWeek) - new Date()) / (6 * 24 * 60 * 60 * 1000) < 1) {
                        // Using 6 since it uses the start of the day
                        // Date is within a week so it is the current week
                        tempWeek = 'current';
                    }

                    data.week = tempWeek;
                }
                // Load Invoice Modal
                this.element.load('/Account/Finance/CashInvoiceComments', data, function() {
                    $ele.css('width', '50vw');
                    setUpTextArea();
                    $('textarea[name="edit-comment"]').parent().hide();
                    const $commentTabs = $('[data-invoice-number-tab]');

                    //comment tabs
                    $commentTabs.on('click', function() {
                        const $self = $(this);
                        const invoiceNumber = $self.data('invoice-number-tab');

                        $('.comment-tab.--active').removeClass('--active');
                        $self.addClass('--active');

                        const $commentSections = $('[data-for-invoice]');

                        $commentSections.hide();
                        $(`[data-for-invoice="${invoiceNumber}"]`).show();
                    });

                    //comment edit button
                    const $editButtons = $('.js-edit-button');
                    if ($editButtons.length) {
                        $editButtons.on('click', function() {
                            //hide comment
                            const $self = $(this);
                            const $parent = $self.parents('.invoice-comment--alt, .invoice-comment');

                            $parent.find('.js-comment-text').hide();
                            $parent.find('textarea[name="edit-comment"]').parent().show();

                            $parent.find('.js-edit-button').hide();
                            $parent.find('.js-delete-button').hide();
                            $parent.find('.js-save-edit').show();
                            $parent.find('.js-cancel-edit').show();
                        });
                    }

                    //Comment delete button
                    const $deleteButtons = $('.js-delete-button');
                    if ($deleteButtons.length) {
                        $deleteButtons.on('click', function() {
                            const $self = $(this);
                            const $parent = $self.parents('.invoice-comment--alt, .invoice-comment');
                            const commentId = $parent.data('comment-id');

                            $parent.find('.js-edit-button').hide();
                            $parent.find('.js-delete-button').hide();

                            //Save to database
                            $.post('/Account/Finance/CashInvoiceDeleteComment', { commentId: commentId }, function(response) {
                                if (response.success) {
                                    $parent.find('.js-comment-text').css('text-decoration', 'line-through');
                                    $parent.find('.js-save-edit').hide();
                                    $parent.find('.js-cancel-edit').hide();
                                } else {
                                    showErrorNotification(response.message);
                                    $parent.find('.js-edit-button').show();
                                    $parent.find('.js-delete-button').show();
                                }
                            });
                        });
                    }

                    //Save edit button
                    const $saveEditButtons = $('.js-save-edit');
                    if ($saveEditButtons.length) {
                        $saveEditButtons.on('click', function() {
                            const $self = $(this);
                            const $parent = $self.parents('.invoice-comment--alt, .invoice-comment');
                            const commentId = $parent.data('comment-id');
                            const newCommentText = $parent.find('textarea[name="edit-comment"]').val();

                            $parent.find('.js-save-edit').hide();
                            $parent.find('.js-cancel-edit').hide();

                            //Save to database
                            $.post('/Account/Finance/CashInvoiceEditComment', {
                                commentId: commentId,
                                newComment: newCommentText,
                            }, function(response) {
                                if (response.success) {
                                    // Hide TextArea
                                    $parent.find('textarea[name="edit-comment"]').parent().hide();
                                    // Replace Comment Text
                                    $parent.find('.js-comment-text').text(newCommentText);
                                    // Show Comment text
                                    $parent.find('.js-comment-text').show();
                                    // Show edit/delete buttons
                                    $parent.find('.js-edit-button').show();
                                    $parent.find('.js-delete-button').show();
                                } else {
                                    showErrorNotification(response.message);
                                    $parent.find('.js-save-edit').show();
                                    $parent.find('.js-cancel-edit').show();
                                }
                            });
                        });
                    }

                    //Cancel edit button
                    const $cancelEditButtons = $('.js-cancel-edit');
                    if ($cancelEditButtons.length) {
                        $cancelEditButtons.on('click', function() {
                            //hide comment
                            const $self = $(this);
                            const $parent = $self.parents('.invoice-comment--alt, .invoice-comment');

                            $parent.find('.js-comment-text').show();
                            const commentText = $parent.find('.js-comment-text').text();
                            $parent.find('textarea[name="edit-comment"]').val(commentText);
                            $parent.find('textarea[name="edit-comment"]').parent().hide();

                            $parent.find('.js-edit-button').show();
                            $parent.find('.js-delete-button').show();
                            $parent.find('.js-save-edit').hide();
                            $parent.find('.js-cancel-edit').hide();
                        });
                    }

                    $(document).trigger('Loaded:InvoiceWindow');
                });
            },
            commissionComments() {
                const $ele = this.element;
                const k_window = $ele.data('kendoWindow');
                const data = {
                    commissionType: $ele.data('type'),
                    entryId: $ele.data('entry-id'),
                    title: $ele.data('title'),
                    Year: $ele.data('year'),
                    Month: $ele.data('month'),
                    Company: $ele.data('company'),
                    SalespersonId: $ele.data('salesperson-id'),
                    Number: $ele.data('number'),
                };

                if (k_window) {
                    setTitle(k_window, data.title);
                    k_window.dragging._preventDragging = true;
                }

                const partial = (nameController === undefined || nameController === 'ssrcommissions') ? '/Finance' : `/Finance/${nameController}`;
                this.element.load(`${partial}/${data.commissionType}Comments`, data, function() {
                    $ele.css('width', '50vw');
                    setUpTextArea();

                    //Edit comment
                    const $editButtons = $('.js-edit-button');
                    if ($editButtons.length) {
                        $editButtons.on('click', function() {
                            //hide comment
                            const $self = $(this);
                            const $parent = $self.parents('.invoice-comment--alt, .invoice-comment');

                            $parent.find('.js-comment-text').hide();
                            $parent.find('textarea[name="edit-comment"]').show();

                            $parent.find('.js-edit-button').hide();
                            $parent.find('.js-delete-button').hide();
                            $parent.find('.js-save-edit').show();
                            $parent.find('.js-cancel-edit').show();
                        });
                    }

                    //Delete comment
                    const $deleteButtons = $('.js-delete-button');
                    if ($deleteButtons.length) {
                        $deleteButtons.on('click', function() {
                            const $self = $(this);
                            const $parent = $self.parents('.invoice-comment--alt, .invoice-comment');
                            const commentId = $parent.data('comment-id');

                            $parent.find('.js-save-edit').hide();
                            $parent.find('.js-cancel-edit').hide();

                            $.post(`${partial}/${data.commissionType}DeleteComment`, {
                                commissionType: $ele.data('type'),
                                entryId: $ele.data('entry-id'),
                                title: $ele.data('title'),
                                Year: $ele.data('year'),
                                Month: $ele.data('month'),
                                Company: $ele.data('company'),
                                SalespersonId: $ele.data('salesperson-id'),
                                Number: $ele.data('number'),
                                commentId: commentId,
                            }, function(response) {
                                if (response === true) {
                                    $parent.find('.js-comment-text').css('text-decoration', 'line-through');
                                    $parent.find('.js-save-edit').hide();
                                    $parent.find('.js-cancel-edit').hide();
                                    showSuccessNotification('Comment deleted.');
                                } else {
                                    showErrorNotification(response.message);
                                    $parent.find('.js-save-edit').show();
                                    $parent.find('.js-cancel-edit').show();
                                }
                            });
                        });
                    }

                    //Save edit
                    const $saveEditButtons = $('.js-save-edit');
                    if ($saveEditButtons.length) {
                        $saveEditButtons.on('click', function() {
                            const $self = $(this);
                            const $parent = $self.parents('.invoice-comment--alt, .invoice-comment');
                            const commentId = $parent.data('comment-id');
                            const updatedCommentText = $parent.find('textarea[name="edit-comment"]').val();

                            $parent.find('.js-save-edit').hide();
                            $parent.find('.js-cancel-edit').hide();

                            $.post(`${partial}/${data.commissionType}UpdateComment`, {
                                entryId: data.entryId,
                                commentId: commentId,
                                commissionType: $ele.data('type'),
                                title: $ele.data('title'),
                                Year: $ele.data('year'),
                                Month: $ele.data('month'),
                                Company: $ele.data('company'),
                                SalespersonId: $ele.data('salesperson-id'),
                                Number: $ele.data('number'),
                                comment: updatedCommentText,
                            }, function(response) {
                                if (response === true) {
                                    // Hide TextArea
                                    $parent.find('textarea[name="edit-comment"]').parent().hide();
                                    // Replace Comment Text
                                    $parent.find('.js-comment-text').text(updatedCommentText);
                                    // Show Comment text
                                    $parent.find('.js-comment-text').show();
                                    // Show edit/delete buttons
                                    $parent.find('.js-edit-button').show();
                                    $parent.find('.js-delete-button').show();
                                    closeKendoWindow($ele);
                                    showSuccessNotification('Comment updated.');
                                } else {
                                    showErrorNotification(response.message);
                                    $parent.find('.js-save-edit').show();
                                    $parent.find('.js-cancel-edit').show();
                                }
                            });
                        });
                    }

                    //Cancel edit button
                    const $cancelEditButtons = $('.js-cancel-edit');
                    if ($cancelEditButtons.length) {
                        $cancelEditButtons.on('click', function() {
                            const $self = $(this);
                            const $parent = $self.parents('.invoice-comment--alt, .invoice-comment');

                            $parent.find('.js-comment-text').show();
                            const commentText = $parent.find('.js-comment-text').text();
                            $parent.find('textarea[name="edit-comment"]').val(commentText);
                            $parent.find('textarea[name="edit-comment"]').hide();

                            $parent.find('.js-edit-button').show();
                            $parent.find('.js-delete-button').show();
                            $parent.find('.js-save-edit').hide();
                            $parent.find('.js-cancel-edit').hide();
                        });
                    }
                });
            },
            AdditionalInformationWindow() {
                const $ele = this.element;
                const k_window = $ele.data('kendoWindow');
                const isReply = $ele.data('is-reply');
                const data = {
                    accrualId: $ele.data('accrual-id'),
                    apRefNumber: $ele.data('accrual-id'),
                    type: namePage,
                };
                let url = '/Account/Accruals/AdditionalInformationComments';

                // Load Invoice Modal
                if (namePage === 'sgaburdenother') {
                    url = '/Finance/SgaAdditionalInformationComments';
                }
                $('.js-previous-comments').load(url, data, function() {
                    $ele.find('#loading.spinner').hide();
                    if (isReply) {
                        $('.js-send-reply').show();
                    } else {
                        $('.js-send-back').show();
                    }

                    setUpTextArea();

                    attachCommentSave();
                });
            },
            ChangeOrderWindow() {
                this.element.find('#loading.spinner').hide();
                const $changeGrid = this.element.find('.js-change-order-grid');
                const k_changeGrid = $changeGrid.data('kendoGrid');
                if (k_changeGrid) {
                    k_changeGrid.dataSource.read();
                } else {
                    $changeGrid.kendoGrid({
                        /* mobile: "phone", */
                        resizable: true,
                        columns: [
                            {
                                field: 'ChangeOrder',
                                title: 'Change Order #',
                                attributes: { class: '' },
                            }, {
                                field: 'Description', title: 'Description', attributes: { class: '' },
                            }, {
                                field: 'Mth', title: 'Month End Date', attributes: { class: '' },
                                type: 'date',
                                format: '{0: M/d/yyyy}',
                            }, {
                                field: 'tot',
                                title: 'Amount',
                                attributes: { class: '' },
                                format: '{0:N2}',
                            },
                        ],

                        dataSource: {
                            autoSync: true, pageSize: 20, schema: {
                                model: {
                                    id: 'ChangeOrder', fields: {
                                        ChangeOrder: { editable: false, type: 'string' },
                                        Description: { editable: false, type: 'string' },
                                        Mth: { editable: false, type: 'date' },
                                        tot: { editable: false, type: 'number' },
                                    },
                                },
                            }, transport: {
                                read: {
                                    url: `/Account/Accruals/GetChangeOrders`, type: 'GET', dataType: 'json',
                                }, parameterMap(data, type) {
                                    const $window = $('#ChangeOrderWindow');
                                    const rs = {
                                        qid: $window.data('qid'),
                                        po: $window.data('purchase-order'),
                                        company: $window.data('company'),
                                        type: namePage,
                                    };
                                    if (type === 'read') {
                                        return rs;
                                    }
                                },
                            },
                        },
                        dataBound(arg) {
                            /* on data bound */
                        },
                        mobile: true,
                        scrollable: true,
                        sortable: false,
                        filterable: false,
                        editable: false,
                        columnMenu: false,
                        pageable: {
                            alwaysVisible: false,
                            pageSizes: true,
                            buttonCount: 20,
                        },
                    });
                }

            },
            //TODO: Refactor this
            AccrualViewpointAttachments() {
                const $ele = $(this.element);
                const data = {
                    company: $ele.data('company'),
                    vendor: $ele.data('vendor'),
                    apRefNum: $ele.data('ap-ref-number'),
                    type: namePage,
                };

                this.element.load('/Account/Accruals/InvoiceAttachments', data, function() {
                });
            },
            ViewpointAttachments() {
                const $ele = $(this.element);
                let data = {
                    company: $ele.data('company'),
                };
                const contract = $('#Contract').val();
                const pco = $ele.data('pco');
                const vendor = $ele.data('vendor');
                const apRefNum = $ele.data('ap-ref-number');
                let action = '';

                if (vendor && apRefNum) {
                    data.vendor = vendor;
                    data.apRefNum = apRefNum.toString();
                    action = 'InvoiceViewpointAttachments';
                } else if (contract && pco) {
                    data.contract = contract;
                    data.pco = pco.toString();
                    action = 'PcoViewpointAttachments';
                }

                this.element.load(`/Attachment/${action}`, data, function() {
                    setUpTextArea();
                });
            },
            PriorQuarterInvoices: function() {
                let $ele = $('.js-prior-invoices'),
                    $window = $(this.element),
                    k_ele = $ele.data('kendoGrid'),
                    readUrl = '/Account/Accruals/MaterialPriorInvoiceData';

                if (namePage === 'subcontractaccrual') {
                    readUrl = '/Account/Accruals/SubcontractPriorInvoiceData';
                }

                if (k_ele) {
                    k_ele.dataSource.read();
                    return;
                }

                $ele.kendoGrid({
                    resizable: true, columns: [
                        {
                            field: 'apRefNum', title: 'Invoice Number', attributes: { class: '' },
                        }, {
                            field: 'invDate', title: 'Invoice Date', attributes: { class: '' }, format: '{0:d}',
                        }, {
                            field: 'invAmount', title: 'Amount',
                            format: '{0: ##,#.00}', attributes: { class: '' },
                        }, {
                            field: 'hasAttachments',
                            title: 'Viewpoint Attachments',
                            attributes: { class: '' },
                            template: function(dataItem) {
                                if (dataItem.hasAttachments) {
                                    return `<div class='k-button' data-ap-ref-number='${dataItem.apRefNum}' data-vendor='${dataItem.vendor}' data-kendoWindow='ViewpointAttachments' data-role='openKendoWindow'>View Attachments</div>`;
                                } else {
                                    return '<div class=\'t-italic t-muted\'>No Attachments</div>';
                                }
                            },
                        }, {
                            field: 'included',
                            title: 'Accruals Required',
                            attributes: { class: '' },
                            type: 'date',
                            template: function() {
                                return '<div class=\'t-italic t-muted\'>N/A</div>';
                            },
                        }, {
                            field: 'sourceReport',
                            title: 'Source',
                            hidden: false,
                            menu: false,
                            attributes: { class: '' },
                            filterable: false,
                            template: function(dataItem) {
                                return '<div class=\'t-italic t-muted\'>Posted Prior to Year End</div>';
                            },
                        },
                    ], dataSource: {
                        autoSync: true, schema: {
                            model: {
                                id: 'apRefNum', fields: {
                                    apRefNum: { editable: false, type: 'string' },
                                    vendor: { editable: false, type: 'int' },
                                    included: { editable: false, type: 'string' },
                                    sourceReport: { editable: false, type: 'string' },
                                    invAmount: { editable: false, type: 'number' },
                                    invDate: { editable: false, type: 'date' },
                                    hasAttachments: { editable: false, type: 'bool' },
                                },
                            },
                        }, transport: {
                            read: {
                                url: readUrl, type: 'GET', dataType: 'json',
                            }, parameterMap: function(data, type) {
                                let windowData = {
                                    qid: $window.data('qid'),
                                    purchaseOrder: $window.data('purchase-order'),
                                    vendor: $window.data('vendor'),
                                };
                                let rs = {};
                                if (type === 'read') {
                                    rs['qid'] = windowData.qid;
                                    rs['poNumber'] = windowData.purchaseOrder;
                                    rs['vendorId'] = windowData.vendor;
                                    return rs;
                                }
                            },
                        },
                    }, dataBound: function(arg) {
                        openCloseWindow();
                    }, mobile: true, scrollable: true, sortable: {
                        mode: 'multiple',
                    }, filterable: true, editable: false, columnMenu: true,
                });
            },
            AccrualBfmOverride() {
                const $ele = $(this.element);
                const data = {
                    type: nameAction,
                    accrualId: $ele.data('accrual-id'),
                    accrualAmount: $ele.data('accrual-amount'),
                    overrideAmount: $ele.data('override-amount'),
                    qid: $ele.data('qid'),
                };

                const subBtn = $('#OverrideSubmit');
                const overrideInput = $('#OverrideAmount').data('kendoNumericTextBox');
                const originalAccrual = $('#OriginalAccrualAmount').data('kendoNumericTextBox');
                originalAccrual.value(data.accrualAmount);
                originalAccrual.enable(false);

                $('#OverrideExplanation').val('');

                originalAccrual.value(data.accrualAmount);
                overrideInput.value(data.accrualAmount);
                if (data.overrideAmount) {
                    overrideInput.value(data.overrideAmount);
                }

                overrideInput.unbind('change');
                overrideInput.bind('change', function(e) {
                    data.overrideAmount = e.sender.value();
                });

                subBtn.unbind('click');
                subBtn.click(function(e) {
                    data.explanation = $('#OverrideExplanation').val();
                    if (data.explanation === '') {

                        showErrorNotification('Override explanation required;');
                    } else {
                        $.post('/Account/Accruals/OverrideAccrual', data, function(r) {
                            if (r.success) {
                                const ovr = r.accrualOverride;
                                const { user } = ovr;
                                const amountSection = $(`.accrual-amount-js[data-accrual-id="${ovr.id}"]`);
                                const currentOvr = amountSection.find('.override-js');

                                if (currentOvr.length === 0) {
                                    const hiddenVal = $(`<input id="OverrideAmount${ovr.id}" type="hidden">`);
                                    const valField = $('<p>').attr('class', 'override-js override-value');
                                    const msgField = $('<p>').attr('class', 'override-js override-message');
                                    const expLabel = $('<strong class="form-item__label">Explanation</strong>');
                                    const expField = $('<p>').attr('class', 'override-js override-explanation');
                                    const currentDisplay = amountSection.find('.accrual-amount-js');
                                    currentDisplay.hide();
                                    hiddenVal.insertBefore(currentDisplay);
                                    valField.insertBefore(currentDisplay);
                                    msgField.insertBefore(currentDisplay);
                                    expLabel.insertBefore(currentDisplay);
                                    expField.insertBefore(currentDisplay);
                                }

                                const ovrHiddenVal = $(`#OverrideAmount${ovr.id}`);
                                const ovrVal = amountSection.find('p.override-js.override-value');
                                const ovrMsg = amountSection.find('p.override-js.override-message');
                                const ovrExp = amountSection.find('p.override-js.override-explanation');
                                const origInput = $(`#DollarAmount${ovr.id}`);
                                const origAmount = kendo.toString(parseFloat(origInput.val()), 'c2');
                                const amount = kendo.toString(ovr.amount, 'c2');
                                const dt = kendo.toString(new Date(ovr.datetimestamp), 'MM/dd/yyyy hh:mm tt');
                                const message = `Original accrual amount has been updated from ${origAmount} to ${amount} by ${user.first} ${user.last} on ${dt}`;
                                ovrVal.text(amount);
                                ovrMsg.text(message);
                                ovrExp.text(ovr.explanation);
                                ovrHiddenVal.val(ovr.amount);

                                origInput.trigger('blur');
                                $ele.data('kendoWindow').close();
                                showSuccessNotification('Override successful.');
                            } else {
                                showErrorNotification('Override not completed.');
                            }
                        });
                    }
                });

                // Resize textbox for new information
                setUpTextArea('.js-ovrexp');

            },
            ManualInvoiceWindow() {
                const $ele = $(this.element);
                const data = {
                    month: $ele.data('month'),
                    year: $ele.data('year'),
                    company: $ele.data('company'),
                };

                $ele.load('/Finance/ManualInvoiceEntry', data, function() {
                    setUpTextArea();

                    $('#saveEntry').on('click', function(event) {
                        event.preventDefault();

                        //ValidateForm
                        const $form = $ele.find('form');
                        $form.find('.k-invalid').removeClass('k-invalid');
                        const $vendor = $form.find('#Vendor');
                        const vendor = $vendor.val();
                        const $invoiceDate = $form.find('#InvoiceDate');
                        const invoiceDate = $invoiceDate.val();
                        const $apRefNumber = $form.find('#InvoiceNumber');
                        const apRefNumber = $apRefNumber.val();
                        const $segment = $form.find('#Segment');
                        const segment = $segment.val();
                        const $description = $form.find('[name="Description"]');
                        const description = $description.val();
                        const $accrualAmount = $form.find('#AccrualAmount');
                        const accrualAmount = $accrualAmount.val();
                        const $accrualRequired = $form.find('#AccrualRequired');
                        const accrualRequired = $accrualRequired.val();

                        if (vendor.trim() === '') {
                            $vendor.parent().addClass('k-invalid');
                        }
                        if (invoiceDate.trim() === '') {
                            $invoiceDate.parent().addClass('k-invalid');
                        }
                        if (apRefNumber.trim() === '') {
                            $apRefNumber.addClass('k-invalid');
                        }
                        if (segment.trim() === '') {
                            $segment.parent().find('.k-dropdown-wrap').addClass('k-invalid');
                        }
                        if (description.trim() === '') {
                            $description.addClass('k-invalid');
                        }
                        if (accrualAmount.trim() === '') {
                            $accrualAmount.parent().addClass('k-invalid');
                        }
                        if (accrualRequired.trim() === '') {
                            $accrualRequired.parent().find('.k-dropdown-wrap').addClass('k-invalid');
                        }

                        if ($form.find('.k-invalid').length) {
                            showErrorNotification('Please ensure all required fields are filled out');
                            return;
                        }

                        //Serialize and send data
                        const data = $form.serialize();
                        $.post('/Finance/SaveManualEntry', data, function(response) {
                            if (response) {
                                $('.js-sga-grid').data('kendoGrid').dataSource.read();
                                $('#ManualInvoiceWindow').data('kendoWindow').close();
                            } else {
                                // Logic to display errors?
                            }
                        });
                    });

                    let $invoiceDate = $('#InvoiceDate');

                    if ($invoiceDate.val() === 'month/day/year') {
                        $invoiceDate.val('');
                    }

                    $(document).trigger('on:AttachmentLoad');
                });
            },
            SgaExplanationWindow() {
                const $ele = $(this.element);
                const data = $('.js-sga-grid').data('kendoGrid').dataSource._data;
                const id = ($ele.data('invId') || '').toString();

                const thisExplanation = data.find(function(e) {
                    return e.invID.toString() === id;
                });

                const explanation = thisExplanation.explanation || '';

                const $explanationTextArea = $ele.find('textarea.js-explanation');
                const $explanationText = $ele.find('p.js-explanation');

                if ($explanationTextArea.length)
                    $explanationTextArea.val(explanation);
                if ($explanationText.length)
                    $explanationText.text(explanation);

                $ele.parent().css('min-width', '50%');

                // Resize textbox for new information
                setUpTextArea('.js-explanation');
            },
            SgaAttachmentWindow() {
                const $ele = $(this.element);
                const data = {
                    Id: ($ele.data('invId') || '').toString(),
                    InvoiceNumber: ($ele.data('apRef') || '').toString(),
                    VendorNumber: ($ele.data('vendor') || '').toString(),
                    company: $('.js-sga-grid').data('company'),
                };
                $ele.load('/Finance/GetSgaAttachmentList', data, function() {
                });
            },
            PmOmChecklistModal() {
                const $self = $(this.element);
                const data = {
                    company: $('#Company').val(),
                    contract: $('#Contract').val(),
                    pco: $self.data('pco'),
                    status: $self.data('status'),
                    amount: $self.data('amount'),
                    cost: $self.data('cost'),
                };
                $self.load('/Operations/PcoApproval/PmOmChecklist', data, function() {
                    $self.css('background', '#f8f9f4');
                    $self.find('[name="Company"]').val(data.company);
                    $self.find('[name="Contract"]').val(data.contract);
                    $self.find('[name="Pco"]').val(data.pco);
                    $self.find('[name="Status"]').val(data.status);
                    $self.find('[name="Amount"]').val(data.amount);
                    $self.find('[name="Cost"]').val(data.cost);
                    //Attach Other option event for change type
                    const $changeOther = $('.js-change-other');
                    const $changeType = $('#ChangeType');
                    if ($changeType.length) {
                        $changeType.on('change', function() {
                            if ($(this).val().includes('Other')) {
                                $changeOther.show();
                            } else {
                                $changeOther.hide();
                                $changeOther.find('textarea').val('');
                            }
                        });
                    }
                    //Attach Other option event for Resource
                    const $resourceOther = $('.js-resource-other');
                    const $resourceUsed = $('#ResourceUsed');
                    if ($resourceUsed.length) {
                        $resourceUsed.on('change', function() {
                            if ($(this).val().includes('Other')) {
                                $resourceOther.show();
                            } else {
                                $resourceOther.hide();
                                $resourceOther.find('textarea').val('');
                            }
                        });
                    }
                    //Attach Other option event for Contractual Auth
                    const $contractualOther = $('.js-contractual-other');
                    const $contractualAuth = $('#ContractualAuthorization');
                    if ($contractualAuth.length) {
                        $contractualAuth.on('change', function() {
                            if ($(this).val().includes('Other')) {
                                $contractualOther.show();
                            } else {
                                $contractualOther.hide();
                                $contractualOther.find('textarea').val('');
                            }
                        });
                    }

                    //Attach Save Button
                    $('.js-checklist-save').on('click', function() {
                        const $form = $(this).parents('form');
                        const data = $form.serialize();

                        $.post('/Operations/PcoApproval/SavePmOmChecklist', data, function(response) {
                            if (response) {
                                $('#pcoDetailGrid').data('kendoGrid').dataSource.read();
                                closeKendoWindow($self);
                            } else {
                                showErrorNotification(response);
                            }
                        });
                    });

                    //Adjust autoheight for text area
                    setUpTextArea();
                });
            },
            PcoApprovalModal() {
                const $self = $(this.element);
                const data = {
                    company: $('#Company').val(),
                    contract: $('#Contract').val(),
                };
                $self.load('/Operations/PcoApproval/PcoApproval', data, function() {
                    $self.css('background', '#f8f9f4');

                    //Set Data for form
                    $self.find('[name="Company"]').val(data.company);
                    $self.find('[name="Contract"]').val(data.contract);
                    $self.find('[name="Pco"]').val(data.pco);

                    //Setup Approval Grid
                    approveGridInit($('.js-pco-approval-grid'));

                    //Attach Save Button
                    approveButtonEvent($self);

                    //Adjust autoheight for text area
                    setUpTextArea();
                });
            },
            PcoCommentModal() {
                const $self = $(this.element);
                const data = {
                    company: $('#Company').val(),
                    contract: $('#Contract').val(),
                    ContractDescription: $('#ContractDescription').val(),
                };
                $self.load('/Operations/PcoApproval/PcoComments', data, function() {
                    $self.find('[name="Company"]').val(data.company);
                    $self.find('[name="Contract"]').val(data.contract);
                    $self.find('[name="ContractDescription"]').val(data.ContractDescription);

                    //Setup Approval Grid
                    approveGridInit($('.js-pco-comment-grid'));

                    //Attach Save Button
                    commentButtonEvent($self);

                    //Adjust autoheight for text area
                    setUpTextArea();
                });
            },
            PcoCommentHistoryModal() {
                const $self = $(this.element);
                const data = {
                    company: $('#Company').val(),
                    contract: $('#Contract').val(),
                    id: $self.data('pco'),
                };
                $self.load('/Operations/PcoApproval/PcoCommentHistory', data, function() {
                    $self.find('[name="Company"]').val(data.company);
                    $self.find('[name="Contract"]').val(data.contract);
                    $self.find('[name="Pco"]').val(data.id);

                    commentHistoryEvent($self);
                    setUpTextArea();
                });
            },
            NewMaintenancePlanModal() {
                const $self = $(this.element);
                const windowData = $self.data();
                const data = {
                    Number: windowData.agreementNumber,
                    company: windowData.company,
                    month: windowData.month,
                    year: windowData.year,
                    salespersonId: windowData.salesperson,
                };
                $self.load('/Finance/AgreementPercentModal', data, function() {
                    setUpTextArea();

                    //Attach Update Button
                    let $saveButton = $self.find('[data-role="save"]');
                    if ($saveButton.length) {
                        $saveButton.click(function() {
                            data.comment = $self.find('[name=CommissionComments]').val();
                            data.commissionPercent = $self.find('#CommissionPercent').val() / 100;
                            data.pin = $self.find('input[type=password]').val();
                            $.post('/Finance/UpdateCommissionPercent', data, function(response) {
                                if (response.success) {
                                    $('.js-ssr-new-maintenance-grid').data('kendoGrid').dataSource.read();
                                    closeKendoWindow($self);
                                } else {
                                    $('.bold.t-danger').text(response.message).show();
                                }
                            });
                        });
                    }
                });
            },
            AddProjectionItemModal() {
                const $self = $(this.element);
                $self.css('background', '#f8f9f4');

                const $addItemButton = $('#addItemButton');

                if ($addItemButton.length) {
                    $addItemButton.unbind('click');
                    $addItemButton.on('click', function() {
                        let data = {
                            pid: $self.find('[name=pid]').val(),
                            mid: $self.find('[name=mid]').val(),
                            Description: $self.find('[name=Description]').val(),
                            ExpectedRecoveryAmount: $self.find('[name=ExpectedRecoveryAmount]').data('kendoNumericTextBox').value(),
                            Comments: $self.find('[name=Comments]').val(),
                        };

                        if (data.Description === '' || data.ExpectedRecoveryAmount === '' || data.Comments === '' || data.ExpectedRecoveryAmount === 0) {
                            showErrorNotification('Please file out all the information');
                            return;
                        }

                        $.post('/Forms/ProjectReview/SaveManualRevenueProjection', data, function(response) {
                            if (response.success) {
                                closeKendoWindow($self);
                                showSuccessNotification(response.message);
                                $('#RevenueProjection_Id').val(0);
                                $('#RevenueProjectionModelForm').submit();
                            } else {
                                showErrorNotification(response.message);
                            }
                        });
                    });
                }
            },
            CommissionsReject() {
                const $ele = $(this.element);
                $ele.parent().css('min-width', '50%');
            },
        };
        const onOpenEvents = Object.assign(WindowEvents.onOpenEvents, tempOpenEvents);
        const tempRefreshEvents = {
            invoiceComments() {
                const data = {
                    contract: $ele.data('project-id'),
                    week: $ele.data('week-id').toLowerCase(),
                };
                this.element.load('/Account/Finance/CashInvoiceComments', data, function() {
                    setUpTextArea();
                });
            },
        };
        const onRefreshEvents = Object.assign(WindowEvents.onOpenEvents, tempOpenEvents);

        $windows.each(function(index, ele) {
            const $ele = $(ele);
            const k_window = $ele.data('kendoWindow');

            k_window._events.open = k_window._events.open || [];
            k_window._events.close = k_window._events.close || [];

            k_window._events.open.addElement(onOpen);
            k_window._events.close.addElement(onClose);
            if (onOpenEvents[ele.id]) k_window._events.open.addElement(onOpenEvents[ele.id]);
            if (onCloseEvents[ele.id]) k_window._events.close.addElement(onCloseEvents[ele.id]);
        });
    }
};
export const openCloseWindow = function() {
    const $openWindow = $('[data-role=openKendoWindow]:not(.bound)');
    const $closeWindow = $('[data-role=closeKendoWindow]:not(.bound)');

    $openWindow.each(function(index, ele) {
        const $thisEle = $(ele);
        const kendoId = $thisEle.attr('data-kendoWindow');
        const $window = $(`#${kendoId}`);
        const k_window = $window.data('kendoWindow');

        if (k_window) {
            $thisEle.click(function(event) {
                event.preventDefault();
                $window.data($thisEle.data());
                k_window.open();
            });
            $thisEle.addClass('bound');
        }
    });
    $closeWindow.each(function(index, ele) {
        const $thisEle = $(ele);
        const k_window = $thisEle.closest('.k-window-content').data('kendoWindow');

        if (k_window) {
            $thisEle.click(function() {
                k_window.close();
            });
            $thisEle.addClass('bound');
        }
    });
};
export const closeKendoWindow = (ele) => {
    const $thisEle = $(ele);
    const k_window = $thisEle.data('kendoWindow');
    if (k_window) {
        k_window.close();
    }
};
export const openKendoWindow = (ele) => {
    const $thisEle = $(ele);
    const k_window = $thisEle.data('kendoWindow');
    if (k_window) {
        k_window.open();
    }
};
const placeWindow = function() {
    const posX = event.clientX + window.scrollX;
    const posY = event.clientY + window.scrollY;
    const $kendoWindow = $('#pcoWindow');
    const $window = $kendoWindow.parent();
    const kendoWindow = $kendoWindow.data('kendoWindow');
    $window.css('top', `${posY}px`).css('left', `${posX}px`);
    kendoWindow.options.position.top = posY;
    kendoWindow.options.position.left = posX;
};
const setTitle = (k_window, title) => {
    k_window.title(title);
};
const resetSpinner = (element, loadingText) => {
    element.html(`<div class="spinner" id="loading"><span class="spinner__text">${loadingText || 'Loading Grid...'}</span></div>`);
};
const setUpTextArea = (elementClass) => {
    textareaAutoHeight.add({
        element: elementClass || '.form-item__autoheight',
    });
    $.event.trigger('on:UiUpdate');
};
